"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var reselect_1 = require("reselect");
var SiteUrlsContext_1 = require("../urls/SiteUrlsContext");
var BreadcrumbFactories_1 = require("./BreadcrumbFactories");
var BreadcrumbsUpdater_1 = require("./BreadcrumbsUpdater");
function createTableBreadcrumbsList(tableId, tableName, databaseId, databaseName, urls, urlSuffix) {
    var breadcrumbs = [BreadcrumbFactories_1.createCatalogBreadcrumb(urls)];
    if (databaseId !== null && databaseName !== null) {
        breadcrumbs.push(BreadcrumbFactories_1.createCatalogDatabaseBreadcrumb(databaseId, databaseName, urls));
    }
    if (tableId !== null && tableName !== null) {
        breadcrumbs.push(BreadcrumbFactories_1.createCatalogTableBreadcrumb(tableId, tableName, urls, urlSuffix));
    }
    return breadcrumbs;
}
var TableBreadcrumbsUpdater = /** @class */ (function (_super) {
    __extends(TableBreadcrumbsUpdater, _super);
    function TableBreadcrumbsUpdater() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line: typedef
        _this.memoizedCreateTableBreadcrumbsList = reselect_1.defaultMemoize(createTableBreadcrumbsList);
        return _this;
    }
    TableBreadcrumbsUpdater.prototype.render = function () {
        var _this = this;
        if (this.props.tableName === null) {
            return null;
        }
        return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(react_router_1.Route, null, function (_a) {
                var location = _a.location;
                var breadcrumbs = _this.memoizedCreateTableBreadcrumbsList(_this.props.tableId, _this.props.tableName, _this.props.databaseId, _this.props.databaseName, urls, location.search);
                return (React.createElement(BreadcrumbsUpdater_1.BreadcrumbsUpdater, { breadcrumbs: breadcrumbs }));
            });
        }));
    };
    return TableBreadcrumbsUpdater;
}(React.Component));
exports.TableBreadcrumbsUpdater = TableBreadcrumbsUpdater;
//# sourceMappingURL=TableBreadcrumbsUpdater.js.map